import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", () => {
  const isLoggedIn = Cookies.get("loggedin") === "true";
  if (!isLoggedIn) return;

  const userEmail = Cookies.get("loggedinas");
  const fullName = Cookies.get("full_name")?.replace(/\+/g, " ");
  const memberId = Cookies.get("user_code");

  document.querySelectorAll(".member-id").forEach((el) => {
    el.textContent = memberId;
  });

  document.querySelectorAll(".member-email").forEach((el) => {
    el.textContent = userEmail;
  });

  document.querySelectorAll(".member-name").forEach((el) => {
    el.textContent = fullName;
  });

  document
    .querySelectorAll(".account-member-id, .account-email")
    .forEach((button) => {
      const tooltip = button.querySelector(".tooltip");

      button.addEventListener("mouseenter", () => {
        if (tooltip.textContent === "Click to copy") {
          tooltip.style.opacity = "1";
          tooltip.style.visibility = "visible";
        }
      });

      button.addEventListener("mouseleave", () => {
        if (tooltip.textContent === "Click to copy") {
          tooltip.style.opacity = "0";
          tooltip.style.visibility = "hidden";
        }
      });

      button.addEventListener("click", function () {
        const textToCopy = this.querySelector(".member").textContent.trim();
        const tooltip = this.querySelector(".tooltip");
        const originalText = tooltip.textContent;

        navigator.clipboard
          .writeText(textToCopy)
          .then(function () {
            tooltip.textContent = "Copied!";
            tooltip.style.opacity = "1";
            tooltip.style.visibility = "visible";

            setTimeout(function () {
              tooltip.textContent = originalText;
              tooltip.style.opacity = "0";
              tooltip.style.visibility = "hidden";
            }, 2000);
          })
          .catch(function (err) {
            console.error("Failed to copy text: ", err);
          });
      });
    });

  document.querySelectorAll(".btn-logout").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      fetch("https://www.reversephone.com/api/v5/session", {
        method: "DELETE",
        credentials: "include",
      })
        .then(() => {
          Cookies.remove("loggedin");
          Cookies.remove("loggedinas");
          Cookies.remove("full_name");
          Cookies.remove("user_code");
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          Cookies.remove("loggedin");
          Cookies.remove("loggedinas");
          Cookies.remove("full_name");
          Cookies.remove("user_code");
          window.location.reload();
        });
    });
  });
});
